import { render, staticRenderFns } from "./BaseHighlightForm.vue?vue&type=template&id=0b346450&scoped=true&"
import script from "./BaseHighlightForm.vue?vue&type=script&lang=js&"
export * from "./BaseHighlightForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BaseHighlightForm.vue?vue&type=style&index=1&id=0b346450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346450",
  null
  
)

export default component.exports